<template>
  <a-input
      v-model:value="value.value"
      :disabled="info.status === 'show'"
      :allowClear="true"
      :placeholder="placeholder"
  />
</template>


<script setup lang="ts">
import {computed, defineProps, reactive, watch} from 'vue';
import {StringSearch, StringSearchOp} from '@/components/business/crud/interface/SearchType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";

const props = defineProps<{
  propName: string;
  widget: StringSearch;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const value: { op: StringSearchOp; value: string; } = reactive({
  op: props.widget.ops[0],
  value: "",
})

watch(() => data.value[props.propName], () => {
  if (data.value[props.propName]) {
    const op = getDataOp();
    if (op) {
      value.op = op;
      if (op === '$like' || op === '$notLike') {
        value.value = data.value[props.propName][op].replace(/%/g, " ").trim();
      } else {
        value.value = data.value[props.propName][op].trim();
      }
    }
  } else {
    value.value = "";
  }
}, {immediate: true, deep: true});

watch(value, () => {
  if (value.op && value.value) {
    if (value.op === "$like" || value.op === "$notLike") {
      data.value[props.propName] = {[value.op]: "%" + value.value.trim().replace(/ /g, "%") + "%"}
    } else {
      data.value[props.propName] = {[value.op]: value.value.trim()}
    }
  } else {
    data.value[props.propName] = undefined;
  }
}, {immediate: true, deep: true});

function getDataOp() {
  return Object.keys(data.value[props.propName] || {})[0] as StringSearchOp | undefined;
}

const placeholder = computed(() => {
  const text = {
    $eq: '等于',
    $neq: '不等于',
    $like: '包含',
    $notLike: '不包含',
  };
  return props.info.title + text[value.op];
})

</script>

<style lang="scss" scoped></style>
